export default __webpack_public_path__ + "static/media/juego_paso38.198aab4f.png";